import { proxy } from 'valtio';

/**
 * State of input fields.
 * Put here any input you want to be controlled by the user
 */
export const inputsState = proxy({
  rcp: null,
  horizon: null,
  region: '',
  regionName: '',
  regionalAggregation: null,
  temporalAggregation: null,
  floodRecurrence: null,
  hydroModel: null,
  month: 6,
  mapType: null,
  threshold: null,
  altitude: NaN,
  level: null,
});

/**
 * State of the map.
 * Put here properties that are not strictly input fields, but transient settings inside the map
 */
export const mapState = proxy({
  selectedLayer: '',
  visualisedLayer: '',
  lat: null,
  lon: null,
  defaultMapLegendOpen: true,
});

/**
 * State of the UI.
 * User interface properties that requires to be shared amongs components.
 * Let's use subcategories to avoid clashing.
 */
export const uiState = proxy({
  drawsers: {
    bottom: false,
    left: false,
    right: false,
    top: false,
  },
  outputRef: null,
  inputRef: null,
  inputExpandRef: null,
  isInputExpanded: false,
});

/**
 * State of the url.
 */
export const urlState = proxy({
  indicator: '',
  selectedLayer: 'nuts_0',
  lat: 0.0,
  lon: 0.0,
  region: '',
  disabled: false,
  theme: null,
});
